import styled, { css } from 'styled-components';
import { ifProp, palette, theme } from 'styled-tools';
import Button from '../Button';

export const UserStatusWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${theme('spacing.xs')} ${theme('spacing.lg')};
  border-top: 1px solid ${palette('borderCard')};
  background-color: ${palette('bgCard')};
`;

export const AvatarGroup = styled.div`
  display: flex;

  ${ifProp(
    'group',
    css`
      gap: 0;
    `,
    css`
      gap: ${theme('spacing.sm')};
    `
  )}
`;

export const WrapperRightComponentBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ParticipantsCount = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 25px;
`;

export const ProgressParticipantWrapper = styled.div`
  background-color: ${palette('greyLight')};
  margin-top: 5px;
`;

export const ProgressParticipants = styled.div`
  height: 5px;
  background-color: ${palette('greenDark')};
  width: ${({ progress }) => progress * 100}%;
`;

export const UserStatusButton = styled(Button)`
  background-color: ${ifProp('done', palette('greenMiddle'))};
  color: ${ifProp('done', 'white')};

  &:hover {
    background-color: ${ifProp('done', palette('greenDark'))};
    color: ${ifProp('done', 'white')};
  }
`;
